// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1s-8t","file":"styles_file__2UIhJ"};